/* eslint-disable no-console */
import querystring from 'querystring';
import { getHeadings, getSubHeadings, isSearch } from './recentSearchDuckCreatorUtils';
export default function saveRecentSearchActionCreator(recentSearchDuck, personalization) {
  return _ref => {
    let {
      requestValues,
      labelsByValues,
      requestQueryValues,
      locationHeading = '',
      canonicalPathname = '',
      additionalFilters = {}
    } = _ref;
    return async dispatch => {
      try {
        const now = new Date();
        const query = {
          ...requestQueryValues,
          ...additionalFilters,
          lastExec: now.toISOString()
        };
        const headings = getHeadings({
          locationHeading
        });
        const subHeadings = getSubHeadings({
          requestValues,
          labelsByValues
        });
        const inventorySearchData = {
          url: `${canonicalPathname}?${querystring.stringify({
            ...requestQueryValues,
            ...additionalFilters
          })}`,
          query,
          timestamp: now.getTime(),
          ...headings,
          ...subHeadings
        };

        // attempt to update local storage when it's considered as a "new" search
        if (isSearch({
          requestValues,
          headings,
          subHeadings
        })) {
          const {
            items
          } = personalization.addInventorySearch(inventorySearchData);
          dispatch(recentSearchDuck.creators.setRecentSearches(items));
        }
      } catch (error) {
        console.log(error);
      }
    };
  };
}